var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlab({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86482 9.93432C3.2689 10.2033 4.56538 10.7951 5.6951 11.6612L12 16.4114M12 16.4114L8.06213 19.3594M12 16.4114L18.3049 11.6612C19.4346 10.7951 20.7311 10.2033 22.1352 9.93432M12 16.4114L15.9379 19.3594M8.06213 19.3594L10.1763 20.9464L11.4728 21.9147C11.6288 22.0223 11.8171 22.0761 12 22.0761C12.1829 22.0761 12.3712 22.0223 12.5272 21.9147L13.8237 20.9464L15.9379 19.3594M8.06213 19.3594L3.64547 16.0348C2.28443 15.0234 1.50977 13.4149 1.50977 11.7472C1.50977 11.1071 1.62274 10.4561 1.86482 9.82672L4.72677 2.37597C4.78057 2.16078 4.99575 1.99939 5.21094 1.9456C5.58751 1.83801 6.02326 2.10699 6.13085 2.48356L8.07289 8.42265H15.9271L17.8692 2.48356C17.9767 2.10699 18.4125 1.83801 18.7891 1.9456C19.0042 1.99939 19.2194 2.16078 19.2732 2.37597L22.1352 9.82672C22.3773 10.4561 22.4902 11.1071 22.4902 11.7472C22.4902 13.4149 21.7156 15.0234 20.3545 16.0348L15.9379 19.3594",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.d42a436f3dbcb7c8f90fe1d23d696f7d.svg";
export { ForwardRef as ReactComponent };